/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { getMonitoringClient } from '@confluence/monitoring';
import { Attribution, isUnauthorizedError } from '@confluence/error-boundary';
import { markErrorAsHandled } from '@confluence/graphql';

import { getIsProductAdminFromQuery } from './getIsProductAdminFromQuery';
import type { useIsProductAdminUseIsProductAdminQuery as useIsProductAdminUseIsProductAdminQuery$data } from './__types__/useIsProductAdminUseIsProductAdminQuery';

export const useIsProductAdmin = () => {
	const {
		data,
		error,
		loading: isAdminCheckLoading,
	} = useQuery<useIsProductAdminUseIsProductAdminQuery$data>(gql`
		query useIsProductAdminUseIsProductAdminQuery {
			user: confluence_atlassianUser(current: true) {
				id
				confluence {
					operations {
						operation
						targetType
					}
				}
			}
			isSiteAdmin
			hasUserAccessAdminRole
		}
	`);

	if (error) {
		if (!isUnauthorizedError(error)) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.ADMIN_EXPERIENCE,
			});
		}
		markErrorAsHandled(error);
	}

	const isProductAdmin = getIsProductAdminFromQuery(data);

	return { isProductAdmin, isAdminCheckLoading };
};
